import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import { ModalService } from 'src/app/services/modal.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { UtilsService } from 'src/app/services/utils.service';
import { environment } from 'src/environments/environment';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { EjemploComponent } from '../modals/ejemplo/ejemplo.component';
import { AppConstants } from 'src/app/app.constants';
import Stepper from 'bs-stepper';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit, AfterViewInit {
  public submitted: boolean = false;

  modulo: any = AppConstants.APLICATION_SUBMODULES.INICIO;
  globales: any = environment.ENVIRONMENT;
  mostrarComponentes: Boolean = this.globales.MOSTRAR_COMPONENTES_INICIO;
  filtrosForm: FormGroup;
  formularioForm: FormGroup;
  faSearch = faSearch;
  invalid: boolean = false;
  tabla: any;
  link: string;
  comboList: any;
  stepperForm: Stepper;

  constructor(private modalService: ModalService, private notificacionService: NotificacionesService,
    private utilsService: UtilsService, private formBuilder: FormBuilder, private elementRef: ElementRef) {
    this.comboList = [{ id: 1, name: 'OPCION 1' }, { id: 2, name: 'OPCION 2' }, { id: 3, name: 'OPCION 3' }];
  }

  ngOnInit(): void {
    this.createForms();
    this.tabla = this.utilsService.inicializarTablaPaginado();
    this.tabla.datos.push({ columna1: new Date(), columna2: 'Dato', columna3: 'Dato', columna4: 'Dato', columna5: 'Dato' });
    this.tabla.datos.push({ columna1: new Date(), columna2: 'Dato', columna3: 'Dato', columna4: 'Dato', columna5: 'Dato' });
    this.tabla.datos.push({ columna1: new Date(), columna2: 'Dato', columna3: 'Dato', columna4: 'Dato', columna5: 'Dato' });
    this.tabla.datos.push({ columna1: new Date(), columna2: 'Dato', columna3: 'Dato', columna4: 'Dato', columna5: 'Dato' });
    this.tabla.datos.push({ columna1: new Date(), columna2: 'Dato', columna3: 'Dato', columna4: 'Dato', columna5: 'Dato' });
    this.tabla.paginaInicial = 1;
    this.tabla.paginaFinal = 1;
    this.tabla.totalRegistros = this.tabla.datos.length;
    //this.descifrar();
  }

  ngAfterViewInit() {
    if (this.mostrarComponentes === true) {
      var stepperFormEl = this.elementRef.nativeElement.querySelector('#stepperForm');
      this.stepperForm = new Stepper(this.elementRef.nativeElement.querySelector('#stepperForm'), {
        animation: true
      });

      var btnNextList = [].slice.call(this.elementRef.nativeElement.querySelectorAll('.btn-next-form'));
      var stepperPanList = [].slice.call(this.elementRef.nativeElement.querySelectorAll('.bs-stepper-pane'));
      var inputMailForm = <HTMLInputElement>document.getElementById('inputMailForm');
      var inputPasswordForm = <HTMLInputElement>document.getElementById('inputPasswordForm');
      var form = stepperFormEl.querySelector('.bs-stepper-content form');

      btnNextList.forEach(function (btn) {
        btn.addEventListener('click', function () {
          this.stepperForm.next();
        })
      })

      stepperFormEl.addEventListener('show.bs-stepper', function (event) {
        form.classList.remove('was-validated')
        var nextStep = event.detail.indexStep;
        var currentStep = nextStep;

        if (currentStep > 0) {
          currentStep--;
        }

        var stepperPan = stepperPanList[currentStep];

        if ((stepperPan.getAttribute('id') === 'test-form-1' && !inputMailForm.value.length) ||
          (stepperPan.getAttribute('id') === 'test-form-2' && !inputPasswordForm.value.length)) {
          event.preventDefault();
          form.classList.add('was-validated');
        }
      });
    }
  }

  question() {
    this.notificacionService.question('Titulo', 'Contenido de la pregunta, ¿desea continuar?').then((result) => {
      if (result.value) {
        this.notificacionService.info('Aceptando accion');
      } else {
        this.notificacionService.info('Rechazando accion');
      }
    });
  }

  info(isAlert) {
    this.notificacionService.info('Contenido de la alerta', isAlert);
  }

  success(isAlert) {
    this.notificacionService.success('Contenido de la alerta', isAlert);
  }

  warning(isAlert) {
    this.notificacionService.warning('Contenido de la alerta', isAlert);
  }

  error(isAlert) {
    this.notificacionService.error('Contenido de la alerta', isAlert);
  }

  createForms() {
    this.filtrosForm = this.formBuilder.group({
      busqueda: ['']
    });
    this.formularioForm = this.formBuilder.group({
      input: ['', Validators.required],
      combo: ['', Validators.required],
      date: [this.utilsService.fromISOJsonDate(new Date()), Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  loadTabla(link?) {
    this.tabla.datos.push({ columna1: new Date(), columna2: 'Dato', columna3: 'Dato', columna4: 'Dato', columna5: 'Dato' });
  }

  processForm() {
    this.submitted = true;
    if (this.formularioForm.invalid) {
      return;
    }
  }

  get fof() {
    return this.formularioForm.controls;
  }

  showModal() {
    let modalRef = this.modalService.mostrarModal(EjemploComponent, 'lg');
    modalRef.result.then((data) => {
      this.notificacionService.info('Accion close modal');
    }, (reason) => {
      this.notificacionService.info('Accion dismiss modal');
    });
  }

  showModalCargando() {
    this.modalService.mostrarModalCargando();
    setTimeout(() => {
      this.modalService.cerrarModalCargando();
    }, 3000);
  }

  descifrar() {
    let llavePublica = '121461908705676683599923353572972495399144523504702091757849779347781156313682971406192143897352485874163029723202454987171223333885893062147040200761167441706413218805403593664283242370409651355554967444077205279511647874463517446134324434676470518735458927589652595728772895536115071032017929324704556374899';
    let llavePrivada = '121461908705676683599923353572972495399144523504702091757849779347781156313682971406192143897352485874163029723202454987171223333885893062147040200761167418535460787875658719863112291790135105895207601319652692757784879138885471958806083668585218908093216454969132489852733843415824901880666231047188702041536';
    let voto = '5684279440916772189812617249943408672014310191555101736499977268407409769962897687628679000544367566566614211318511637600711508575620377054323401185138819749866264148060555365527155989300174906694591051342176037488613824055376144696283693321727032715263119999312774440182219345713296360121463699459438024277394609968683597874678770516436979895407119136298245031082522062456113279040701345030835683763947896300859109485722272445556195652960929517114948972910006164002905794627017633889415898816982726211983734066539399201656110046298954516900447717568734585047238235783046250927411519757862283812080177211693196505610';
    let publicKey = this.utilsService.obtenerLlavePublicaPaillier(llavePublica);
    let privateKey = this.utilsService.obtenerLlavePrivadaPaillier(publicKey, llavePrivada);
    let votoDescifrado = this.utilsService.descifrarPaillier(voto, privateKey);
    console.log('votoDescifrado', votoDescifrado);
  }

}
